import { render, staticRenderFns } from "./EditContest.vue?vue&type=template&id=cbe172a4&scoped=true&"
import script from "./EditContest.vue?vue&type=script&lang=js&"
export * from "./EditContest.vue?vue&type=script&lang=js&"
import style0 from "./EditContest.vue?vue&type=style&index=0&id=cbe172a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbe172a4",
  null
  
)

export default component.exports